'use client';
import React from 'react';
import { PlayCircleOutlineRounded } from '@mui/icons-material';
import VideoPlayer from 'src/shared/components/video-player/components/video-player';

interface ModalVideoProps {
  trailerPlaybackId?: string;
  trailerPlaybackToken?: string;
  placeholderImg: string;
}

export const ModalVideo: React.FC<ModalVideoProps> = ({
  trailerPlaybackId,
  trailerPlaybackToken,
  placeholderImg,
}) => {
  return (
    <>
      <div
        className={
          !trailerPlaybackId && !trailerPlaybackToken
            ? 'relative w-full rounded-xl overflow-hidden h-[170px] md:h-[400px] mb-6'
            : 'relative w-full rounded-xl overflow-hidden mb-6'
        }
        style={
          !trailerPlaybackId && !trailerPlaybackToken && placeholderImg
            ? {
                backgroundImage: `url(${placeholderImg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }
            : {}
        }
      >
        {trailerPlaybackId && trailerPlaybackToken && (
          <>
            <VideoPlayer
              playbackId={trailerPlaybackId}
              playbackToken={trailerPlaybackToken}
              videoId={trailerPlaybackId}
              videoTitle={''}
              simpleControls={true}
            />
          </>
        )}
      </div>
    </>
  );
};
